module.exports = __webpack_public_path__ + "074f3fcd59d3ee50636877930cad4bff.svg";